// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { statusPlugin } from '@atlaskit/editor-plugin-status';
export type {
	StatusPlugin,
	StatusPluginDependencies,
	StatusPluginActions,
	StatusPluginCommands,
	StatusState,
	StatusType,
	StatusPluginOptions,
	ClosingPayload,
	UpdateStatus,
} from '@atlaskit/editor-plugin-status';
